import { useSelector } from "react-redux";

import useWindowEventListener from "seneca-common/utils/hooks/events/useWindowEventListener";

import {
  showNetworkLostToast,
  showNetworkReconnectToast
} from "features/common/toasts/network-connectivity";
import { getModalOpen } from "features/ui-state/selectors";

import useShowResetPasswordsToast from "./reset-passwords/useShowResetPasswordsToast";
import useShowSurveyToast from "./surveys/useShowSurveyToast";
import ToastContainer from "./ToastContainer";

export default function ToastProvider() {
  useWindowEventListener("online", showNetworkReconnectToast);
  useWindowEventListener("offline", showNetworkLostToast);
  useShowSurveyToast();
  useShowResetPasswordsToast();
  const modalOpen = useSelector(getModalOpen);

  if (modalOpen) {
    return null;
  }

  return <ToastContainer />;
}
